import { makeObservable, observable, action, computed } from 'mobx';
import AlertViewModel from 'src/components/Alert/viewModel';

export default class PurchaseModalViewModel extends AlertViewModel {
  constructor(props) {
    super(props);

    makeObservable(this);
  }
}
